import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { QRCodePage } from "./qrcode/qrcode";
const routes: Routes = [
    { path: 'mysport', loadChildren: () =>
      import('./mysport/mysport.module').then(m => m.MysportModule)
    },
    { path: 'qrcode', loadComponent: () =>
      import('./qrcode/qrcode').then(m => m.QRCodePage)
    },
    { path: 'settings', loadChildren: () =>
      import('./settings/settings.module').then(m => m.SettingsModule)
    },
  ];
@NgModule({
    declarations: [
      QRCodePage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class MeModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }